export interface ISakStatus {
    [key: string]: { key: string; mapped: string };
}

export enum SakStatusEnum {
    SLETTET = 'Slettet',
}

export const SakStatus: ISakStatus = {
    Active: { key: 'Active', mapped: 'Aktiv' },
    Closed: { key: 'Closed', mapped: 'Avsluttet' },
    Postponed: { key: 'Postponed', mapped: 'Utsatt' },
    Deleted: { key: 'Deleted', mapped: 'Slettet' },
    Merged: { key: 'Merged', mapped: 'Sammenslått' },
    WaitingForCustomer: {
        key: 'WaitingForCustomer',
        mapped: 'Venter på kunde',
    },
    WaitingForThirdParty: {
        key: 'WaitingForThirdParty',
        mapped: 'Venter på 3dje part',
    },
};
